import { render, staticRenderFns } from "./Template102Lembrete.vue?vue&type=template&id=4eb7a914"
import script from "./Template102Lembrete.vue?vue&type=script&lang=js"
export * from "./Template102Lembrete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports